import ApplicationController from '../application_controller'

export default class extends ApplicationController {

	static targets = [
		'merit',
		'deleteButton',
	]

	connect() {
		this.updateRemoveButtons()
	}

	meritTargetConnected(element) {
		this.updateRemoveButtons()
	}

	meritTargetDisconnected(element) {
		this.updateRemoveButtons()
	}

	// This will restrict removing the last Merit because there must be at least one.
	updateRemoveButtons() {
		if (this.meritTargets.length > 1) { // show all remove buttons
			for (const button of this.deleteButtonTargets) {
				button.classList.remove('d-none')
			}
		}
		else { // hide the last delete button
			for (const button of this.deleteButtonTargets) {
				button.classList.add('d-none')
			}
		}
	}
}

